// ConfirmEmail.tsx
import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useI18n } from "../../utils/translate/i18n/useI18n";
import { getApiUrl } from "../../utils/getApiUrl";

const ConfirmEmail: React.FC = () => {
  const { t } = useI18n();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const hasFetched = useRef(false);

  const token = searchParams.get("token");

    useEffect(() => {
    if (!token || hasFetched.current) return;
    hasFetched.current = true;

    fetch(getApiUrl(`auth/confirm-email?token=${token}`))
        .then(async (resp) => {
        const data = await resp.json();
        if (resp.ok) {
            setStatus("success");
          setMessage(t("Twój adres e-mail został potwierdzony! Możesz się teraz zalogować."));
        } else {
            setStatus("error");
          setMessage(data.error || t("Potwierdzenie nie powiodło się."));
        }
        })
        .catch(() => {
        setStatus("error");
        setMessage(t("Błąd sieci. Spróbuj ponownie."));
        });
      }, [t, token]);

  return (
    <>
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "40vh" }}>
        <div className="text-center">
          {status === "loading" && <p>{t("Trwa potwierdzanie adresu e-mail...")}</p>}
          {status === "success" && (
            <>
              <h3 className="text-success mb-3">{t("✓ E-mail potwierdzony")}</h3>
              <p>{message}</p>
              <button className="btn btn-success mt-2" onClick={() => navigate("/login")}>
                {t("Przejdź do logowania")}
              </button>
            </>
          )}
          {status === "error" && (
            <>
              <h3 className="text-danger mb-3">{t("Potwierdzenie nie powiodło się.")}</h3>
              <p>{message}</p>
              <button className="btn btn-danger mt-2" onClick={() => navigate("/")}>
                {t("Wróć do strony głównej")}
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ConfirmEmail;